<form [formGroup]="form" class="filter-wrapper">
  <div class="select-wrapper">
    <select
      class="select"
      id="supplier"
      name="supplier"
      required
      formControlName="supplier"
    >
      <option class="option" value="" [class.active]="supplierSelected === ''">
        Todos los proveedores
      </option>
      @for (sup of supplierList; track $index) {
        <option
          class="option"
          [value]="sup"
          [class.active]="supplierSelected === sup"
        >
          {{ sup }}
        </option>
      }
    </select>
    <img
      class="select-icon"
      src="/icons/chevron-down.svg"
      alt="Arrow Down Icon"
    />
  </div>
  <div class="date-range">
    <input class="input" type="date" formControlName="startDate" />
    <input class="input" type="date" formControlName="endDate" />
  </div>
  <div class="select-wrapper">
    <select
      class="select"
      id="branch"
      name="branch"
      required
      formControlName="branch"
    >
      <option class="option" value="" [class.active]="branchSelected === ''">
        Todas las filiales
      </option>
      @for (branch of branchList; track $index) {
        <option
          class="option"
          [value]="branch"
          [class.active]="branchSelected === branch"
        >
          {{ branch }}
        </option>
      }
    </select>
    <img
      class="select-icon"
      src="/icons/chevron-down.svg"
      alt="Arrow Down Icon"
    />
  </div>
  <div>
    <input
      class="input"
      type="text"
      placeholder="Buscar por número de serie"
      formControlName="serial"
    />
  </div>
  @if (showActions) {
    <app-button
      class="button"
      variant="primary"
      label="Aprobar selección"
      (click)="handleApprove()"
    ></app-button>
    <app-button
      class="button"
      variant="secondary"
      label="Denegar selección"
      (click)="handleDeny()"
    ></app-button>
  }
</form>
